module.exports = __webpack_public_path__ + "img/pudding_half.2f2b4102.svg";